<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span> 
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/community_manager/wip" *ngIf="role=='community_manager'">Wip</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/designer/wip" *ngIf="role=='designer'">Wip</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: lead_status}" *ngIf="role=='community_manager'">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer' && lead_details">Lead </span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}} - {{lead_details.project_details.name}}</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="row px-4">
  <app-shared-top-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status' [payments_tab]='"active"'></app-shared-top-menu>
   <div class="col-12">
    <div class="row mb-5">
      <div class="col-md-12 bg-white pb-3">
        <ul class="nav nav-tabs ss-nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active addCursor text-center mr-3" (click)="getSet('pre_10_percent')" [ngClass]="{'active': selectedSet == 'pre_10_percent'}">10% BOQs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link active addCursor text-center mr-3" (click)="getSet('10_50_percent')" [ngClass]="{'active': selectedSet == '10_50_percent'}">10-50% BOQs</a>
          </li>
        </ul>

        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <button *ngIf="role == 'designer'" type="button" class="btn btn-pink bt-boq" data-toggle="modal" data-target="#addPayment"  id="bt-disable" (click)="openAddPaymentModal()">Add Payment </button>
            <button type="button" class="btn btn-pink bt-boq" data-toggle="modal" data-target="#paymentHistoryModal" (click)="getPaymentHistory()">Payment History </button>
          </div>
          <div class="col-md-12" >
  	        <div class="tableDiv " *ngIf="approveList && approveList.length>0">
  	          <div class="table-responsive">
  	            <table class="table ">
  	              <thead class="thead-dark">
  	                <tr>
  	                  <th scope="col" class="firstTh">#</th>
  	                  <th scope="col">REFERENCE NUMBER</th>
  	                  <th scope="col">STATUS</th>
  	                  <th scope="col">PRICE</th>
  	                  <th scope="col">PERCENT DISCOUNT</th>
  	                  <th scope="col">FINAL AMOUNT</th>
                      <th scope="col">PAID AMOUNT</th>
                      <th scope="col">
                        <span *ngIf="selectedSet == 'pre_10_percent'">10% PAID?</span>
                        <span *ngIf="selectedSet == '10_50_percent'">50% PAID?</span>
                      </th>
                      <th scope="col">LAST PAYMENT STATUS</th>
  	                  <th class="lastTh"></th>
  	                </tr>
  	              </thead>
  	              <tbody>
  	               <tr  *ngFor="let quotation of approveList; let i = index; " [attr.data-index]="i" class="box-list">
                    <td>{{ i +1 }}</td>
                    <td><a [routerLink]="['/lead/'+lead_id+'/project/'+project_id+'/boq_modular/'+quotation.id]" class="a_hrefLink" routerLinkActive='active' >{{quotation.reference_number}}</a></td>
                    <td>{{ quotation.status }}</td>
                    <td>{{ quotation.net_amount }}</td>
                    <td>
                      <span *ngIf="quotation.discount_value != null">{{ quotation.discount_value }}</span>
                      <span *ngIf="quotation.discount_value == null">0</span>
                    </td>
                    <td>{{ quotation.total_amount  |  number : '1.2-2' }}</td>
                    <td>
                      <span *ngIf="quotation.paid_amount != null">{{ quotation.paid_amount }}</span>
                      <span *ngIf="quotation.paid_amount == null">0</span>
                    </td>
                    <td>
                      <span *ngIf="selectedSet == 'pre_10_percent'">{{quotation.ten_per_true}}</span>
                      <span *ngIf="selectedSet == '10_50_percent'">{{quotation.per_50_true}}</span>
                    </td>
                    <td>
                      <span *ngIf="quotation.last_payment_status == 'pending'">Pending</span>
                      <span *ngIf="quotation.last_payment_status == true">Approved</span>
                      <span *ngIf="quotation.last_payment_status == false">Rejected</span>
                      <span *ngIf="quotation.last_payment_status == null">N/A</span>
                    <td>
                      <div *ngIf="role == 'designer'">
                        <label class="form-check-label" for="proposal{{quotation.id}}">
                          <input
                            class="form-check-input boq-checkbox"
                            type="checkbox"
                            id="proposal{{quotation.id}}"
                            name="proposal{{quotation.id}}"
                            [checked]="quotation.checked" (change)="onCheckChange($event)" value="{{quotation.id}}" [disabled]='quotation.copied == true' >
                        </label>
                      </div>
                      <div *ngIf="role == 'community_manager' &&  selectedSet == 'pre_10_percent'">
                        <input type="button" name="" class="btn btn-pink" value="Approve" (click) = "approveBoq(quotation.id)" *ngIf="!quotation.per_10_approved_by_id && quotation.last_payment_status == true && quotation.ten_per_true == false" >
                      </div>
                      <div *ngIf="role == 'community_manager' &&  selectedSet == '10_50_percent'">
                        <input type="button" name="" class="btn btn-pink" value="Approve" (click) = "approveBoq(quotation.id)" *ngIf="quotation.per_50_true == false && quotation.last_payment_status == true" >
                      </div>
                    </td>
                    <!-- <td>{{ proposal.discount_status }}</td> -->
                  
                  </tr>
  	                  
  	              </tbody>
  	            </table>  
  	            <!-- <p>{{paymentForm.value | json}}</p> -->
  	          </div>
  	        </div>          
	        </div> 
          <div class="col-md-12 not-found " *ngIf="approveList && approveList.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p> 
          </div> 
        </div>
      </div>
    </div>
  </div>

</div> 
<!-- Modal create for payment -->
<div id="addPayment" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">

  
    <div class="modal-content modal-change">
      <div class="modal-header modal-header-chng">
        <h4 class="modal-title modal-title-change">Add Payment Details</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal" (click)="paymentReset()">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change">
        

      <div class="row">
        <div class="col-md-12">
          <form [formGroup]="paymentForm">
            
            <!-- <select formControlName = "payment_type" class="form-control mb-2">
              <option [selected] = "true">Select Payment Type</option>
              <option value="initial_design">Initial Design</option>
              <option value="final_design">Final Design</option>
            </select> -->
            <!-- <input type="text" class="form-control mb-2" placeholder="Remarks" formControlName = "quotations"> -->
            <input type="text" class="form-control mb-2" placeholder="Paid Amount" formControlName = "amount">
            <select formControlName = "mode_of_payment" class="form-control mb-2" (change) = "changePaymentMode($event)">
              <option [selected] = "true" disabled="true">Select Payment Mode</option>
              <option value="NEFT/RTGS">NEFT/RTGS</option>
              <option value="cheque">Cheque</option>
            </select>

            <input type="text" class="form-control mb-2 cheque-mode" placeholder="Bank Name" formControlName = "bank">
            <input type="text" class="form-control mb-2 cheque-mode" placeholder="Branch Name" formControlName = "branch">
            <label class="cheque-mode">Date of cheque</label>
            <input type="date" class="form-control mb-2 cheque-mode" formControlName = "date_of_checque" >
            <label class="cheque-mode">Upload Image*</label>
            <input type="file" class="form-control cheque-mode"  formControlName="image" (change)="onChange($event)">
            <label class="neft-mode">Transaction Number</label>
            <input type="text" class="form-control mb-2 neft-mode" formControlName = "transaction_number">
            <label class="neft-mode">Payment Date</label>
            <input type="date" class="form-control mb-2 neft-mode" formControlName = "date">
          </form>
          <pre>
            <!-- {{paymentForm.value | json}} -->
          </pre>
        </div>
        <div class="col-md-12 text-right" >
           <button class="btn  interalBtnColor addCursor mt-2" (click)="savePayment()" [disabled] = "!paymentForm.valid" >Add Payment</button>
          
        </div>
       
       
      </div>
    </div>

  </div>
 </div>
</div>

<!-- Modal end here -->

<!--Payment history modal starts-->
<div id="paymentHistoryModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-change">
      <div class="modal-header modal-header-chng">
        <h4 class="modal-title modal-title-change">Payments History</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change">
        <div class="row">
          <div class="col-md-12">
            
            <collapsible-table [type]="'accordion'" bordered class="table">

            <thead class="thead-dark">

              <collapsible-table-row>
                <th scope="col" class="firstTh">#</th>
                <th scope="col">DATE/DATE OF CHEQUE</th>
                <th scope="col">PAYMENT MODE</th>
                <th scope="col">AMOUNT</th>
                <th scope="col">PAID AMT<br><span>(by customer)</span></th>
                <th scope="col">TRANSACTION NUMBER</th>
                <th scope="col">BANK NAME</th>
                <th scope="col">BRANCH NAME</th>
                <th scope="col">PAYMENT TYPE</th>
                <th scope="lastTh"></th>
                  
              </collapsible-table-row>
            </thead>
           
            <tbody>
              <ng-container *ngFor="let history of payment_details_Arr; let i = index; " [attr.data-index]="i" >
              <collapsible-table-row [detail]="detail1" (click)="getPaymentQuotation(history.id)">
                <td class="capitalize">{{ i +1 }}</td>
                <td class="capitalize">
                  <span *ngIf="history.date">{{history.date | date:'fullDate'}}</span>
                  <span *ngIf="history.date_of_checque">{{history.date_of_checque}}</span>
                </td>
               
                <td *ngIf="history.mode_of_payment != 'cheque' ">{{history.mode_of_payment}}</td>
                <td *ngIf="history.mode_of_payment == 'cheque' "><a href="{{ history.image }}" target="_blank"  style="color: #007bff">{{history.mode_of_payment}} </a></td>
                <!-- <td>{{payment.bank}}</td> -->

                <td class="capitalize">{{history.total_amount}}</td>
                <td class="capitalize">{{history.amount}}</td>
                <td class="capitalize" *ngIf="history.mode_of_payment == 'NEFT/RTGS' ">{{history.transaction_number}}</td>
                <td class="capitalize" *ngIf="history.mode_of_payment != 'NEFT/RTGS' ">N/A</td>
                <td class="capitalize" *ngIf="history.mode_of_payment == 'cheque' ">{{history.bank}}</td>
                <td class="capitalize" *ngIf="history.mode_of_payment != 'cheque' ">N/A</td>
                <td class="capitalize" *ngIf="history.mode_of_payment == 'cheque' ">{{history.branch}}</td>
                <td class="capitalize" *ngIf="history.mode_of_payment != 'cheque' ">N/A</td>
                <td class="capitalize">{{history.payment_type | replaceChar}}</td>
                
              </collapsible-table-row>
              <collapsible-table-row-detail #detail1>
                <table>
                  <tr class="table-row">
                    <td scope="col">REF NO.</td>
                    <td scope="col">LAST EDITED ON</td>
                    <td scope="col">PRICE EXPIRY</td>
                    <td scope="col">STATUS</td>
                    <td scope="col">TOTAL AMOUNT</td>
                  </tr>
                  <tr *ngFor="let payment of payment_details ">
                    <td class="capitalize">{{payment.reference_number}}</td>
                    <td>{{payment.updated_at | date:'dd MMMM, y @ h:mma'}}</td>
                    
                    <td >{{payment.expiration_date}}</td>
                    <td>{{payment.status}}</td>
                    <td>{{payment.net_amount}}</td>
                    
                  </tr>
                </table>
              </collapsible-table-row-detail> 
              </ng-container>
            </tbody>     
            </collapsible-table>
                
          </div>
          <div class="col-md-12 not-found " *ngIf="payment_details_Arr && payment_details_Arr.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p> 
          </div> 
        </div>
      </div>
    </div>
  </div>
</div>

<!--Payment history modal ends-->



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/payments/payments.component.html